import { render, staticRenderFns } from "./reply-composer.vue?vue&type=template&id=1cbcad69&scoped=true"
import script from "./reply-composer.vue?vue&type=script&lang=ts"
export * from "./reply-composer.vue?vue&type=script&lang=ts"
import style0 from "./reply-composer.vue?vue&type=style&index=0&id=1cbcad69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbcad69",
  null
  
)

export default component.exports